<template>
  <div class="abi">
    <div class="abi-title">实验室检测能力</div>
    <div class="abi-inner flex flex-row flex-wrap">
      <div class="abi-item" v-for="(item, index) in ability" :key="index">
        <div class="abi-cate">{{ item.laboratoryAbilityTypeName }}</div>
        <div class="flex flex-row">
          <div class="abi-bar" :style="{ width: `${item.radio}%` }"></div>
          <div class="abi-num">{{ item.childrenCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { abilitySort } from "@/api/home";
export default {
  data() {
    return {
      ability: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$axios.get(abilitySort);
      const vals = res.map(({ childrenCount }) => childrenCount);
      const maxVals = Math.max(...vals);
      res.forEach((item) => {
        item.radio = ((item.childrenCount / maxVals) * 100).toFixed(0);
      });
      this.ability = res;
    },
  },
};
</script>
<style lang="scss" scoped>
.abi {
  padding-top: 40px;
  &-inner {
    width: 70%;
    margin: 0 auto;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
  }
  &-item {
    width: 50%;
    padding: 0 60px;
    margin-bottom: 15px;
  }
  &-bar {
    margin-top: 5px;
    background: #6ca5f8;
    border-radius: 10px;
    height: 10px;
    margin-right: 10px;
  }
}
</style>
